// extracted by mini-css-extract-plugin
export var moveGradient = "MovingGradientLite-module--moveGradient--f7c08";
export var wrapper = "MovingGradientLite-module--wrapper--8f775";